import { ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekListItemText = styled(ListItemText)(({ theme }) => ({}));

export { PeekListItemText, PeekListItemText as default };
